import Swal from "sweetalert2";
import quotationApis from "../../../api/master/quotations";
import dayjs from "dayjs";

export const saveDraft = async (
  data: any,
  newDraft: any,
  navigate: any,
  setDisableSubmit: any,
  mode?: string
) => {
  console.log("data", data);
  // return;
  if (!newDraft) {
    await newOrder(data, navigate, setDisableSubmit, "DRAFT");
  }
  if (newDraft) {
    // await editDraftRFQ(data, navigate, setDisableSubmit, "DRAFT");
  }
};

export const newOrder = async (
  previousFormData: any,
  navigate: any,
  setDisableSubmit: any,
  mode: any
) => {
  console.log("DRAFT", mode);
  const _formData: any = new FormData();
  let _filesData: any = [];
  let quotationData: any = {
    ...previousFormData,
  };
  try {
    const quotationLines = await Promise.all(
      previousFormData?.items.map(async (lineItem: any, index: number) => {
        let obj = { ...lineItem };
        let finalObj: any = {
          quotationLineId: obj?.quotationLineId,
          materialId: Number(obj?.materialName),
          materialName: obj?.materialLabel || "",
          categoryId: Number(obj?.materialCategory),
          categoryName: obj?.categoryLabel || "",
          uomId: Number(obj?.uomId),
          quantity: Number(obj?.quantity),
          specification: obj?.specification || "",
          makeInfo: obj?.makeInfo || [],
          deliveryAddressId: Number(obj?.deliveryAddressId) || null,
          deliveryDate:
            (quotationData?.needByDateType === "LINE_LEVEL" &&
              obj?.needByDate &&
              dayjs(obj?.needByDate).format("DD-MMM-YYYY")) ||
            "",
        };
        if (obj?.file && obj?.file[0]) {
          finalObj.fileIndex = _filesData.length;
          _formData.append("files", obj?.file[0]);
          _filesData.push({
            fileIndex: _filesData.length,
            module: "Quotation",
            moduleFileType: "Special Instructions",
            level: "LINE_LEVEL",
          });
        } else if (obj?.dms?.length > 0) {
          _filesData.push({
            fileIndex: _filesData.length,
            module: "Quotation",
            moduleFileType: "Special Instructions",
            level: "LINE_LEVEL",
          });
        }
        if (previousFormData?.needByDateType === "Line Level") {
          finalObj.needByDate = dayjs(obj?.needByDate).format("YYYY-MM-DD");
        }
        if (previousFormData?.deliveryAddressType == "Line Level") {
          finalObj.deliveryAddressId = Number(obj?.deliveryAddressId);
        }
        if (obj?.prLineId) {
          finalObj.prLineId = Number(obj?.prLineId);
        }
        return finalObj;
      })
    );

    const quotationHeader = {
      prId: quotationData?.prId || null,
      quotationId: quotationData?.quotationId || null,
      rfqId: quotationData?.numberingMode === 'auto' ? null : (quotationData?.rfqId || null),
      billingAddressId: quotationData?.billingAddressId || null,
      quotationFor: quotationData?.quotationFor || "",
      quotationDescription: quotationData?.quotationDescription || "",
      costCenter: quotationData?.costCenter || undefined,
      lastSubmissionDate:
        dayjs(quotationData?.lastSubmissionDate).format("YYYY-MM-DD HH:mm:ss") || "",
      deadlineType: quotationData?.deadlineType || "SOFT",
      siteId: quotationData?.siteId || null,
      contractorId: quotationData?.contractorId || null,
      additionalCharges: quotationData?.additionalCharges || "Flexible",
      deliveryLevelType: quotationData?.deliveryAddressType || "",
      deliveryAddressId:
        quotationData?.deliveryAddressType === "ORDER_LEVEL"
          ? quotationData?.deliveryAddressId
          : null,
      deliveryDateType: quotationData?.needByDateType || "",
      deliveryDate:
        quotationData?.needByDateType == "LINE_LEVEL"
          ? undefined
          : quotationData?.needByDate || "",
      autoRelease: quotationData?.autoRelease || "",
      paymentTerms: quotationData?.paymentTerms || "",
      preferredBrands: (() => {
        const brands = quotationData?.preferredBrands;
        // If it's already an array, return it (could be array of objects or array of IDs)
        if (Array.isArray(brands)) {
          return brands;
        }
        // If it's an empty string, null, or undefined, return empty array
        if (!brands || (typeof brands === "string" && brands.trim() === "")) {
          return [];
        }
        // For any other case, return empty array
        return [];
      })(),
      expectedCreditDays: quotationData?.creditDays || null,
      pricingMode: quotationData?.pricingMode || "Base Price",

      approvalRequired: quotationData?.approvalRequired || "",
      supplierDocsRequired: quotationData?.supplierDocsRequired || "",
      conversionRemarks: quotationData?.conversionRemarks || null,
      status: mode == "DRAFT" ? "DRAFT" : null,
      isStrictApproval: quotationData?.isStrictApproval || false,
      isSealedBid: quotationData?.isSealedBid === "Y" ? true : false,
      sealedBidSubmissionDate:
        quotationData?.isSealedBid === "Y" && quotationData?.sealedBidSubmissionDate
          ? dayjs(quotationData.sealedBidSubmissionDate).format("YYYY-MM-DD HH:mm:ss")
          : null,
      postalAddress:
        quotationData?.isSealedBid === "Y"
          ? quotationData?.postalAddress || null
          : null,
      isStrictEvaluationTimer: quotationData?.isStrictEvaluationTimer === "Y" ? true : false,
      evaluationDate:
        quotationData?.isStrictEvaluationTimer === "Y" && quotationData?.evaluationDate
          ? dayjs(quotationData.evaluationDate).format("YYYY-MM-DD HH:mm:ss")
          : null,
    };

    let additionalData = {
      selectedSuppliers: Object.keys(quotationData)
        .filter((key) => key.startsWith("supplier_") && quotationData[key])
        .map((key) => parseInt(key.replace("supplier_", ""))),
      publishTo: "MARKET_PLACE",
    };

    const approvals = JSON.parse(quotationData.approvalsData);
    if (approvals?.data?.length > 0 && quotationHeader.approvalRequired) {
      _formData.append("quotationApprovals", JSON.stringify(approvals?.data));
    } else {
      _formData.append("quotationApprovals", JSON.stringify([]));
    }
    if (quotationData.documents !== undefined) {
      let requiredDocs = quotationData.documents.documents?.map(
        (doc: any, index: number) => ({
          documentName: doc.documentName || "",
          mandatory: doc.mandatory || 0,
        })
      );
      console.log("requiredDocs", requiredDocs);
      _formData.append("requiredDocs", JSON.stringify(requiredDocs));
    } else {
      _formData.append("requiredDocs", JSON.stringify([]));
    }

    console.log("_formData", _formData);

    if (quotationData.attachments) {
      quotationData.attachments.forEach((attachment: any, index: number) => {
        if (!attachment) {
          return;
        }
        const file = attachment?.originFileObj;
        _formData.append(`files`, file);
        _filesData.push({
          fileIndex: _filesData.length,
          module: "Quotation",
          moduleFileType: "attachments",
          level: "HEADER_LEVEL",
        });
      });
    }
    console.log("_formData", _formData);

    if (quotationData.instructions) {
      const instructionsFile = new Blob([quotationData.instructions], {
        type: "text/html",
      });
      _formData.append(
        `files`,
        new File([instructionsFile], "instructions.html", {
          type: "text/html",
        })
      );
      _filesData.push({
        fileIndex: _filesData.length,
        module: "Quotation",
        moduleFileType: "instructions",
        level: "HEADER_LEVEL",
      });
    }

    console.log("_formData", _formData);

    if (quotationData.termsAndConditions) {
      const termsAndConditionsFile = new Blob(
        [quotationData.termsAndConditions],
        {
          type: "text/html",
        }
      );
      _formData.append(
        `files`,
        new File([termsAndConditionsFile], "termsandconditions.html", {
          type: "text/html",
        })
      );
      _filesData.push({
        fileIndex: _filesData.length,
        module: "Quotation",
        moduleFileType: "termsAndConditions",
        level: "HEADER_LEVEL",
      });
    }
    // if (quotationData.deliveryAddressType != "Line Level") {
    //   quotationData.deliveryAddressId = quotationDatadeliveryAddressId;
    // }
    if (previousFormData?.needByDateType == "Order Level") {
      quotationData.needByDate = dayjs(quotationData.needByDate).format(
        "YYYY-MM-DD"
      );
    }

    let selectedSuppliers = Object.keys(quotationData)
      .filter((key) => key.startsWith("supplier_") && quotationData[key])
      .map((key) => parseInt(key.replace("supplier_", "")));

    _formData.append("quotationHeader", JSON.stringify(quotationHeader));
    _formData.append("quotationLines", JSON.stringify(quotationLines));
    _formData.append("docKeys", JSON.stringify(_filesData));

    _formData.append("additionalData", JSON.stringify(additionalData));
    console.log("_formData", _formData);
    createQuotations(_formData, navigate, setDisableSubmit, mode);
  } catch (error) {
    console.log(error);
    setDisableSubmit(false);
  }
};

const createQuotations = async (
  data: any,
  navigate: any,
  setDisableSubmit: any,
  mode?: string
) => {
  try {
    const dataApI: any = await quotationApis.quotationsCreationMethod(data);
    const { status, error, response, message }: any = dataApI;
    if (status === true) {
      Swal.fire("Created!", response.rfqId, "success");
      navigate(`/view-rfqs`);
    } else {
      Swal.fire("Error!", message, "error");
    }
  } catch (error) {
    console.error("Submission error:", error);
  }
  setDisableSubmit(false);
};
